<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { RouterView } from 'vue-router'
import { PLayout, PHeader } from '@previo/design-system'
import { Color } from '@previo/codebooks'
import { useFeatureFlags } from '@previo/feature-flags'
import AppMenu from '~/layouts/components/app-menu/AppMenu.vue'

onBeforeMount(async () => {
  await useFeatureFlags().waitForInit()
})
</script>

<template>
  <p-layout :color="Color.GREY_100">
    <p-header>
      <app-menu />
    </p-header>

    <div>
      <router-view />
    </div>
  </p-layout>
</template>
